import { render, staticRenderFns } from "./RegistTypeColumn.vue?vue&type=template&id=044844b9&"
import script from "./RegistTypeColumn.vue?vue&type=script&lang=js&"
export * from "./RegistTypeColumn.vue?vue&type=script&lang=js&"
import style0 from "./RegistTypeColumn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('044844b9')) {
      api.createRecord('044844b9', component.options)
    } else {
      api.reload('044844b9', component.options)
    }
    module.hot.accept("./RegistTypeColumn.vue?vue&type=template&id=044844b9&", function () {
      api.rerender('044844b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/table/RegistTypeColumn.vue"
export default component.exports